import * as React from "react";
import type { SVGProps } from "react";

export const ThumbsDownSolid = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="-0.5 -0.5 18.5 18.5" fill="none" {...props}>
    <path
      fill="currentColor"
      d="M0 1.969v8.437c0 .466.378.844.844.844h2.812a.844.844 0 0 0 .844-.844V1.97a.844.844 0 0 0-.844-.844H.844A.844.844 0 0 0 0 1.969M1.406 9a.844.844 0 1 1 1.688 0 .844.844 0 0 1-1.688 0m9.563 9c-.71 0-1.037-1.381-1.193-2.032-.183-.762-.372-1.55-.893-2.07-1.141-1.144-1.74-2.601-3.133-3.977a.42.42 0 0 1-.125-.3V2.106c0-.23.184-.418.414-.422.557-.01 1.29-.32 1.851-.569C9.007.62 10.396.001 12.094 0h.1c1.503 0 3.282.015 4 1.045q.442.638.216 1.57c.573.599.88 1.717.575 2.628.617.823.674 1.973.328 2.794l.004.003c.418.42.686 1.1.683 1.73-.006 1.067-.92 2.043-2.094 2.043H12.33c.257.996 1.17 1.832 1.17 3.323C13.5 17.72 11.813 18 10.969 18"
    />
  </svg>
);
